/** Shared light tooltip surface (Radix + Recharts). */
export const CONSOLE_TOOLTIP_SURFACE_CLASS =
  "overflow-hidden rounded-md border border-border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md";
